import React from "react";

const Loader = () => (
  <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-slate-900/45 backdrop-blur-sm">
    <img src="/fish.svg" alt="Φόρτωση..." className="h-32 w-32 animate-pulse-soft drop-shadow-lg" />
  </div>
);

export default Loader;
